export default[{
  code: 'contract001006'
}, {
  code: 'contract001006001'
}, {
  code: 'contract001006002'
},
{code: 'contract002004001'},
{code: 'contract002004002'},
{code: 'contract01'},
{code: 'networkoperate'},
{code: 'networkoperate001'},
{code: 'networkoperate001001'},
{code: 'networkoperate001002'},
{code: 'gridset'}

// {code: 'contract03103'},
// {code: 'contract03104'},
// {code: 'contract03105'},
// {code: 'contract03106'},
// {code: 'contract03107'},
// {code: 'contract03108'}
]



// WEBPACK FOOTER //
// ./src/area-base/store/developMenu.js